<template>
<div>
    <!-- modal -->
    <b-modal id="accountingBooksReceiptFormModal" centered size="xl" no-close-on-backdrop ref="accountingBooksReceiptFormModal" :title="$t('accountingBooksReceipt.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @close="clear()" hide-footer>
        <b-form @submit.prevent="addOrUpdate">
        <div class="custom-search d-flex justify-content-end">
            <b-row>
                <b-col>
                    <b-button type="submit" v-if="sequence == 0" variant="outline-primary" size="sm" class="mr-1" @click.prevent="addOrUpdate">
                        {{$t('others.ok_title')}}
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <validation-observer ref="simpleRules">
                <b-row>
                    <b-col class="col-md-4">
                        <label for="accountingTransactionType-input">{{ $t('accountingBooksReceipt.accounting_transaction_type') }}</label>
                        <b-form-group>
                            <validation-provider :name="$t('accountingBooksReceipt.accounting_transaction_type')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                <b-form-select id="accountingTransactionType-input" size="sm" v-model="accountingTransactionTypeSelect" value-field="id" text-field="name" :options="accountingTransactionTypeOption" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col class="col-md-4">
                        <label for="number-input">{{ $t('accountingBooksReceipt.number') }}</label>
                        <b-form-group>
                            <b-form-input disabled size="sm" id="number-input" v-model="number" />
                        </b-form-group>
                    </b-col>
                    <b-col class="col-md-4">
                        <label for="accounting-books-receipt-payment-type-input">{{ $t('accountingBooksReceipt.payment_type') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="accountingPaymentMethodTypeSelect" value-field="id" text-field="name" :options="accountingPaymentMethodTypeOption" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-4">
                        <label for="accounting-books-receipt-document-date-input">{{ $t('accountingBooksReceipt.documentDate') }}</label>
                        <CustomDatePicker :datePickerValidateOption="1" v-model="documentDate"></CustomDatePicker>
                    </b-col>

                    <b-col class="col-md-4">
                        <label for="accounting-books-receipt-date-input">{{ $t('accountingBooksReceipt.date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="2" v-model="date"></CustomDatePicker>
                    </b-col>
                    <b-col class="col-md-4">
                        <label for="accounting-books-receipt-document-type-input">{{ $t('accountingBooksReceipt.document_type') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="accountingTransactionDocumentTypeSelect" value-field="id" text-field="name" :options="accountingTransactionDocumentTypeOption" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-12">
                        <label for="accounting-books-receipt-description-input">{{ $t('accountingBooksReceipt.description') }}</label>
                        <b-form-group>
                            <b-form-textarea id="accounting-books-receipt-description-input" :placeholder=" $t('accountingBooksReceipt.description')" rows="3" v-model="description" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-4" >
                        <label for="amount-input">{{ $t('accountingBooksReceipt.amount') }}</label>
                        <cleave id="amount-input" :options="cleaveOptions" v-model="totalAmount" class="form-control form-control-sm" disabled/>
                    </b-col>
                    <b-col v-if="accountingTransactionDocumentTypeSelect != 0" class="col-md-4">
                        <label for="accounting-books-receipt-document-no-input">{{ $t('accountingBooksReceipt.reference') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('accountingBooksReceipt.account_no')" rules="required">
                                <b-form-input size="sm" id="accounting-books-receipt-document-no-input" v-model="reference" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col v-else class="col-md-4">
                        <label for="accounting-books-receipt-document-no-input">{{ $t('accountingBooksReceipt.reference') }}</label>
                        <b-form-group>
                            <b-form-input disabled size="sm" id="accounting-books-receipt-document-no-input" v-model="reference" />
                        </b-form-group>
                    </b-col>
                    <b-col class="col-md-4">
                        <label for="employee-input">{{ $t('accountingBooksReceipt.employee') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
                        </b-form-group>
                    </b-col>
                </b-row>
        </validation-observer>
        <b-card :hidden="hiddenControl">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab :title="$t('accountingBooksReceipt.standart')" active style="width:100%;">
                            <b-card-text>
                                <accounting-books-receipt-standart-list @totalAmountEmitted ="totalAmountFunction" :subsidiaryLedgerId="this.subsidiaryLedgerId" :isRecordLocked="this.sequence == 0" :accountingTransactionId="this.id" :getAccountingBooksList="getAccountingBooksList" :getAccountingBooksReceiptList="getAccountingBooksReceiptList" ref="accountingBooksReceiptStandartList"></accounting-books-receipt-standart-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
        </b-form>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getAccountingBooksList: {
            type: Function
        },
        getAccountingBooksReceiptList: {
            type: Function
        },
        subsidiaryLedgerId: {
            Number
        },
        year: {
            type: Number,
            default: null
        },
        companyId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            id: 0,
            employeeSelect: 0,
            employeeOption: [],
            accountingPaymentMethodTypeSelect: 0,
            accountingPaymentMethodTypeOption: [],
            accountingTransactionDocumentTypeSelect: 0,
            accountingTransactionDocumentTypeOption: [],
            accountingTransactionTypeSelect: 0,
            accountingTransactionTypeOption: [],
            amount: 0.0,
            number: 0,
            documentDate: null,
            date: null,
            reference: '',
            sequence: 0,
            description: '',
            hiddenControl: true,
            cleaveOptions: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2,
                delimiter: '.',
                numeralDecimalMark: ',',
            },
            accountingTransactionDetailListToCopy: [],
            totalAmount: 0,
            rawTotalAmount: 0,
            watchEnabled: true,
            accountingTransactionDetailListToCopyFlag: true
        }
    },
    methods: {
        validateDocumentDateYear() {
            if (this.id != 0 || !this.year || !this.documentDate) return true
            const docYear = parseInt(this.documentDate.substring(0, 4), 10)
            if (docYear !== this.year) {
                this.$WarningAlert(this.$t('alerts.document_date_year_mismatch', { year: this.year }))
                return false
            }
            return true
        },
        totalAmountFunction(totalAmountEmitted) {
            this.rawTotalAmount = parseFloat(totalAmountEmitted)
            this.watchEnabled = false
            this.totalAmount = String(parseFloat(totalAmountEmitted).toFixed(2)).replace('.', ',')
            this.$nextTick(() => {
                this.watchEnabled = true
            })
        },
        showInfo(id, accountingTransactionCopyResponse) {   
            this.$refs['accountingBooksReceiptFormModal'].show()
            this.watchEnabled = false;
            if (accountingTransactionCopyResponse != null) {
                this.accountingTransactionDetailListToCopy = accountingTransactionCopyResponse.accountingTransactionDetailList
                if(this.accountingTransactionDetailListToCopy.length > 0 ){
                    this.totalAmount = this.accountingTransactionDetailListToCopy
                    .filter(item => item.accountingTransactionDetailTypeId === 1)
                    .reduce((sum, item) => sum + item.amount, 0);
                }
                this.hiddenControl = false
                this.accountingTransactionDocumentTypeOption = accountingTransactionCopyResponse.accountingTransactionDocumentTypeList
                this.accountingTransactionTypeOption = accountingTransactionCopyResponse.accountingTransactionTypeList
                this.accountingPaymentMethodTypeOption = accountingTransactionCopyResponse.accountingPaymentMethodTypeList
                this.employeeOption = accountingTransactionCopyResponse.employeeList
                this.documentDate = accountingTransactionCopyResponse.accountingTransaction.documentDate
                this.date = accountingTransactionCopyResponse.accountingTransaction.date
                this.reference = accountingTransactionCopyResponse.accountingTransaction.reference
                this.description = accountingTransactionCopyResponse.accountingTransaction.description
                this.amount = accountingTransactionCopyResponse.accountingTransaction.amount // To do Şu an için atıl duruyor 2026
                this.number = accountingTransactionCopyResponse.accountingTransaction.number
                this.accountingTransactionDocumentTypeSelect = accountingTransactionCopyResponse.accountingTransaction.accountingTransactionDocumentTypeId
                this.accountingTransactionTypeSelect = accountingTransactionCopyResponse.accountingTransaction.accountingTransactionTypeId
                this.sequence = accountingTransactionCopyResponse.accountingTransaction.sequence
                if (accountingTransactionCopyResponse.accountingTransaction.employeeId != null && accountingTransactionCopyResponse.accountingTransaction.employeeId != 0) {
                    this.employeeSelect = accountingTransactionCopyResponse.accountingTransaction.employeeId
                } else {
                    this.employeeSelect = localStorage.getItem('EmployeeId')
                }
                this.accountingPaymentMethodTypeSelect = accountingTransactionCopyResponse.accountingTransaction.accountingPaymentMethodTypeId

                this.accountingTransactionDocumentTypeOption.splice(0, 0, this.$nullSelected())
                this.employeeOption.splice(0, 0, this.$nullSelected())
                this.accountingTransactionTypeOption.splice(0, 0, this.$nullSelected())
            } else {
                this.id = id
                if (this.id == 0) {
                    this.hiddenControl = true
                } else {
                    this.hiddenControl = false
                }
                const data = {
                    id: this.id
                }
                const controller = {
                    name: 'AccountingTransaction'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.accountingTransactionDocumentTypeOption = response.data.accountingTransactionDocumentTypeList
                        this.accountingTransactionTypeOption = response.data.accountingTransactionTypeList
                        this.accountingPaymentMethodTypeOption = response.data.accountingPaymentMethodTypeList
                        this.employeeOption = response.data.employeeList
                        this.documentDate = response.data.accountingTransaction.documentDate
                        this.date = response.data.accountingTransaction.date
                        this.reference = response.data.accountingTransaction.reference
                        this.description = response.data.accountingTransaction.description
                        this.amount = response.data.accountingTransaction.amount
                        this.number = response.data.accountingTransaction.number
                        this.accountingTransactionDocumentTypeSelect = response.data.accountingTransaction.accountingTransactionDocumentTypeId
                        this.accountingTransactionTypeSelect = response.data.accountingTransaction.accountingTransactionTypeId
                        this.sequence = response.data.accountingTransaction.sequence

                        if (response.data.accountingTransaction.employeeId != null && response.data.accountingTransaction.employeeId != 0) {
                            this.employeeSelect = response.data.accountingTransaction.employeeId
                        } else {
                            this.employeeSelect = localStorage.getItem('EmployeeId')
                        }

                        this.accountingPaymentMethodTypeSelect = response.data.accountingTransaction.accountingPaymentMethodTypeId

                        this.accountingTransactionDocumentTypeOption.splice(0, 0, this.$nullSelected())
                        this.employeeOption.splice(0, 0, this.$nullSelected())
                        //this.accountingPaymentMethodOption.splice(0, 0, this.$nullSelected())
                        this.accountingTransactionTypeOption.splice(0, 0, this.$nullSelected())
                    } else {
                        this.$bvModal.hide('accountingBooksReceiptFormModal')
                        this.$WarningAlert(response.data.resultMessage)
                    }
                     this.watchEnabled = true;
                })
            }

        },
        clear(){
            this.accountingTransactionDetailListToCopy = null
            this.accountingTransactionCopyResponse = null
            this.id = 0
            this.totalAmount = 0
            this.accountingTransactionTypeSelect = 0
            this.accountingTransactionDetailListToCopyFlag = true
        },
        async addOrUpdate() {
            let success = await  this.$refs.simpleRules.validate();
                if (success) {
                    if (!this.validateDocumentDateYear()) return
                    const data = {
                        id: this.id,
                        subsidiaryLedgerId: this.subsidiaryLedgerId,
                        accountingTransactionTypeId: this.accountingTransactionTypeSelect,
                        accountingTransactionDocumentTypeId: this.accountingTransactionDocumentTypeSelect,
                        accountingPaymentMethodTypeId: this.accountingPaymentMethodTypeSelect,
                        documentDate: this.documentDate,
                        date: this.date,
                        reference: this.reference,
                        description: this.description,
                        amount: this.rawTotalAmount,
                        employeeId: this.employeeSelect
                    }
                    const controller = { name: 'AccountingTransaction' }
                    const payload = { data: data,controller: controller}
                       
                    const response = await  this.$store.dispatch('moduleAuth/save', payload);
                        if (response.data.resultStatus == true) {
                            this.id = response.data.accoutingTransactionId
                            this.getAccountingBooksList()
                            this.getAccountingBooksReceiptList()
                            this.hiddenControl = false
                            //Transaction COPY Code Check
                            if (this.accountingTransactionDetailListToCopy !== null && this.accountingTransactionDetailListToCopyFlag) {
                                for (const element of this.accountingTransactionDetailListToCopy) {
                                    let amountCv = element.amountCv

                                    if (element.currency && element.currency !== 'TL' && element.currency !== 'TRY') {
                                        const ratePayload = {
                                            data: {
                                                requestDate: this.documentDate,
                                                currencyToSell: 'TL',
                                                currencyToBuy: element.currency,
                                                amount: element.amount
                                            },
                                            controller: { name: 'Currency', actionName: 'ExchangeCurrency' }
                                        }
                                        try {
                                            const rateResponse = await this.$store.dispatch('moduleAuth/customService', ratePayload)
                                            if (rateResponse.data.resultStatus == true) {
                                                const rate = this.companyId == 3
                                                    ? rateResponse.data.currencyToBuy.banknoteSelling
                                                    : rateResponse.data.currencyToBuy.buying
                                                amountCv = rate * element.amount
                                            }
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    } else {
                                        amountCv = element.amount
                                    }

                                    const data = {
                                        accountingTransactionId: this.id,
                                        accountingId: element.accountingId,
                                        reference: element.reference,
                                        accountingTransactionDetailTypeId: element.accountingTransactionDetailTypeId,
                                        amount: element.amount,
                                        amountCv: amountCv,
                                        currencyId: element.currencyId,
                                        description: element.description,
                                        exchangeDate: this.documentDate,
                                        recordDate: element.recordDate
                                    }
                                    const controller = { name: 'AccountingTransactionDetail' }
                                    const payload = { data: data, controller: controller }

                                    const detailResponse = await this.$store.dispatch('moduleAuth/save', payload);
                                    if (detailResponse.data.resultStatus != true) {
                                        success = false
                                        this.$WarningAlert(detailResponse.data.resultMessage)
                                        break;
                                    }
                                }
                                if (success) {
                                    this.$bvModal.hide('accountingBooksReceiptStandartFormModal')
                                    this.getAccountingBooksReceiptList()
                                    this.$refs.accountingBooksReceiptStandartList.getAccountingBooksReceiptStandartList()
                                    this.accountingTransactionDetailListToCopyFlag = false
                                }
                            }
                             if(success) this.$SaveAlert()
                        } else {
                            this.$WarningAlert(this.$t("alerts." + response.data.resultMessage))
                        }
                    
                }
        },
    },
    watch: {
        totalAmount(newVal, oldVal){
            if(newVal!= oldVal && this.id && this.watchEnabled){
               this.addOrUpdate();
            }
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
